/**
 * Helpers liste commerçants (comptes, badges).
 */

/** Logo affiché en liste (assets locaux ou URL boutique). */
export function getCommercantLogoUrl(commercant) {
  if (!commercant?.nom) return commercant?.logo || null;
  const name = commercant.nom.toLowerCase();
  if (name.includes('villoing')) return '/assets/villoingpiscine-logo.png';
  if (name.includes('ilpiatto') || name.includes('il piatto')) return '/assets/ilpiatto-logo.png';
  if (name.includes('sushi')) return '/assets/sushilover-logo.png';
  return commercant.logo || null;
}

export function buildAccountsByCommercantId(accountsSummary = []) {
  const map = new Map();
  for (const item of accountsSummary) {
    const cid = item.commercant?.id || item.commercantId;
    if (cid) {
      map.set(cid, { ...item, status: item.status });
    }
  }
  return map;
}

export function getAccountStatusForCommercant(accountsMap, commercantId) {
  return accountsMap.get(commercantId)?.status || 'UNKNOWN';
}

export function serviceBadges(commercant) {
  const badges = [];
  if (commercant.livraison) badges.push({ key: 'livraison', label: 'Livraison', className: 'bg-blue-100 text-blue-800' });
  if (commercant.clickAndCollect) {
    badges.push({ key: 'cc', label: 'C&C', className: 'bg-purple-100 text-purple-800' });
  }
  if (commercant.moduleCaisse) {
    badges.push({ key: 'pos', label: 'Caisse', className: 'bg-slate-100 text-slate-800' });
  }
  return badges;
}
